<template>
  <div>
    <van-popup v-model="showPopup" position="bottom" :style="{ height: '75%' }" @close="handleClose">
      <div class="popup">
        <div class="popup-title">创建我的话术</div>
        <div class="group">
          <div>分组</div>
          <van-dropdown-menu active-color="#3974c4" class="select-group">
            <!-- <van-dropdown-item v-model="params.groupId" :options="groupList" /> -->
            <van-dropdown-item :title="groupSelectName" ref="levelGroupItem">
              <multipleSelect ref="selectChild" :dataList="firstLevelList" :groupItem="groupItem"
                @getGroupItem="getGroupItem" @getIdName="getIdName" @getShowPopupTree="getShowPopupTree">
              </multipleSelect>

            </van-dropdown-item>
          </van-dropdown-menu>
          <!-- <div class="add-group" @click="showOverlay = true">创建分组</div> -->
          <van-dropdown-menu active-color="#3974c4" class="add-group">
            <van-dropdown-item title="新增分组" ref="item" @open="handleAddGroup">
              <div class="add-wrap-div">
                <!-- 一级 -->
                <div class="m-b-20">
                  <div style="font-weight: bold;">新增一级分组</div>
                  <div class="add-div">
                    <van-field v-model="paramsLevel1.name" label="分类:" rows="1" autosize type="textarea" clearable
                      placeholder="请输入标题"></van-field>
                  </div>
                  <van-button round type="info" @click="handleLevel(1)">保存</van-button>
                </div>

                <!-- 二级 -->
                <div class="m-b-20" v-if="firstLevelList.length > 0">
                  <div style="font-weight: bold;margin-bottom:15px;">新增二级分组</div>
                  <div class="add-div">
                    <div class="add-div-flex">
                      <div>一级分组:</div>
                      <van-dropdown-menu active-color="#3974c4" class="select-group">
                        <van-dropdown-item v-model="paramsLevel2.parentId" :options="firstLevelList" />
                      </van-dropdown-menu>
                    </div>
                    <van-field v-model="paramsLevel2.name" label="分类:" rows="1" autosize type="textarea" clearable
                      placeholder="请输入标题"></van-field>
                  </div>
                  <van-button round type="info" @click="handleLevel(2)">保存</van-button>
                </div>

                <!-- 三级 -->
                <div class="m-b-20" v-if="twoLevelList.length > 0">
                  <div style="font-weight: bold;margin-bottom:15px;">新增三级分组</div>
                  <div class="add-div">
                    <div class="add-div-flex">
                      <div>二级分组:</div>
                      <van-dropdown-menu active-color="#3974c4" class="select-group">
                        <!-- <van-dropdown-item v-model="paramsLevel3.parentId" :options="twoLevelList" /> -->
                        <van-dropdown-item :title="twoGroupName" ref="twoGroupItem" @open="handleTwoGroup">
                          <div v-for="(item, index) in firstLevelList" :key="index">
                            <div style="padding: 15px 5px 8px 20px;"
                              :style="paramsLevel3.parentId === itema.id? 'color: #3974c4' : 'color: #333'"
                              v-for="(itema, indexa) in item.children" :key="indexa" @click="handleTwoGroupItem(itema)">
                              {{item.text}} --- {{itema.text}}
                            </div>
                          </div>
                        </van-dropdown-item>
                      </van-dropdown-menu>
                    </div>
                    <van-field v-model="paramsLevel3.name" label="分类:" rows="1" autosize type="textarea" clearable
                      placeholder="请输入标题"></van-field>
                  </div>
                  <van-button round type="info" @click="handleLevel(3)">保存</van-button>
                </div>
              </div>
            </van-dropdown-item>
          </van-dropdown-menu>
        </div>
        <van-form>
          <van-field v-model="params.title" label="标题" :rules="[{ required: true, message: '' }]" rows="1" autosize
            type="textarea" clearable placeholder="请输入标题">
          </van-field>
          <van-field class="popup-content" label="内容" v-model="params.content"
            :rules="[{ required: true, message: '' }]" rows="1" autosize type="textarea" clearable placeholder="请输入内容">
          </van-field>
          <van-field v-model="params.effectiveTime" label="时间" rows="1" autosize type="textarea" clearable></van-field>

          <div class="popup-btn">
            <van-button type="primary" @click="handleSave">保存</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <!-- 创建分组 -->
    <!-- <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="wrapper" @click.stop>
        <div class="block" />
      </div>
    </van-overlay> -->
  </div>
</template>
<script>
import multipleSelect from '../components/multipleSelect.vue'
import { flatten } from '../utils/index'

export default {
  props: {
    // groupList: {
    //   type: Array,
    //   default: []
    // }
  },
  components: { multipleSelect },
  data () {
    return {
      groupList: [],
      firstLevelList: [],
      twoLevelList: [],
      showOverlay: false,
      showPopup: true,
      params: {
        groupId: '',
        title: '',
        content: '',
        effectiveTime: '',
        isContent: 1,
        isCorporate: 0
      },
      paramsLevel1: {
        isCorporate: 0,
        name: '',
        parentId: 0
      },
      paramsLevel2: {
        isCorporate: 0,
        name: '',
        parentId: null
      },
      paramsLevel3: {
        isCorporate: 0,
        name: '',
        parentId: null
      },
      twoGroupName: '',
      groupSelectName: '',
      selectNum: 0,
      groupItem: {},
      showPopupTree: false,
      deptId: null,
      deptList: []
    }
  },
  created () {
    this.initDeptList()
    // this.initGroupList()
    // if (this.groupList.length > 0) {
    //   this.groupList.forEach(item => {
    //     item.value = item.id
    //   })
    //   this.params.groupId = this.groupList[0].id
    // }
    // console.log(this.groupList, 'this.groupList');
  },
  methods: {
    // 
    initDeptList () {
      this.$http
        .get("/scrm/v1/wxcp-chat-tool/p/contentShareDeptMulTenancy", {})
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.deptList = []
            res.data.forEach(item => {

              if (item.deptList === null || item.deptList === undefined) {
                item.deptList = []
              }
              if (item.deptList.length > 0) {
                item.deptList.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.deptList.push(item.deptList)
              }

            })
            this.deptList = flatten(this.deptList);
            console.log(this.deptList, 'this.deptList');
            if (this.deptList.length > 0) {
              this.deptList.forEach(item => {
                item.text = item.tenancyName + '/ ' + item.name
                item.value = item.id
              })
              this.deptId = this.deptList[0].id
              this.speechgroupList()
            } else {
              this.groupItem = {}
              this.groupId = null
              this.groupList = []
              this.groupName = ''
              this.speechListcontent = []
            }
          }
        });
    },
    //查询话术库分组
    speechgroupList () {
      this.$http
        .get("/scrm/v1/wxcp-chat-tool/p/findCtSpeechTreeMul", {
          params: {
            corpId: this.$store.state.auth.corpId,
            owner: 1,
            deptId: this.deptId
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.firstLevelList = []
            res.data.forEach(item => {

              if (item.tree === null || item.tree === undefined) {
                item.tree = []
              }
              if (item.tree.length > 0) {
                item.tree.forEach(tree => {
                  tree.value = tree.id
                  tree.tenancyName = item.tenancy.name || ''
                });

                if (item.tenancy.id == this.$store.state.auth.tenancyId) {
                  // this.firstLevelList.push(item.tree)
                  this.firstLevelList = item.tree
                }
              }
            })

            this.firstLevelList = flatten(this.firstLevelList);
            this.twoLevelList = []
            this.firstLevelList.forEach(item => {
              if (item.children === null || item.children === undefined) {
                item.children = []
              }
              if (item.children.length > 0) {
                item.children.forEach(aitem => {
                  aitem.value = aitem.id
                  this.twoLevelList.push(aitem)
                })
              }
            });

            if (this.firstLevelList.length > 0) {
              this.groupItem = this.firstLevelList[0]
              this.params.groupId = this.firstLevelList[0].id
              this.groupSelectName = this.firstLevelList[0].text
            } else {
              this.groupItem = {}
              this.params.groupId = null
              this.groupSelectName = ''
            }

            this.paramsLevel2.parentId = this.firstLevelList[0].id
            this.paramsLevel3.parentId = this.twoLevelList[0].id
            this.twoGroupName = this.twoLevelList[0].text
          }
        });
    },
    handleAddGroup () {
      //   this.initLevelGroupList()
    },
    // 新增分组点击选择二级分组
    handleTwoGroup () {

    },
    // 新增分组
    handleTwoGroupItem (item) {
      this.paramsLevel3.parentId = item.id
      this.twoGroupName = item.text
      //   this.$refs.twoGroupItem.toggle();
    },
    // getGroupItem
    getGroupItem (val) {
      console.log(val, 'val');
      this.groupItem = val
      this.params.groupId = val.id
      this.groupSelectName = val.text
      if (this.selectNum > 0 && val.children.length < 1) {
        this.$refs.levelGroupItem.toggle();
      }
      this.selectNum++
    },
    getIdName (val) {
      this.groupSelectName = val.join('/')
    },
    // getShowPopupTree
    getShowPopupTree (val) {
      this.showPopupTree = val
    },

    handleClose (val) {
      this.showPopup = false
      this.$emit('getShowPopupStaff', this.showPopup)
    },
    // 创建话术
    handleSave () {
      if (!this.params.title || !this.params.content) {
        return
      }

      this.$http
        .post("/scrm/v1/ct-speech/m/add", this.params)
        .then((res) => {
          if (res.code === 1) {
            this.$emit('getShowPopupStaff', false)
            this.$parent.speechList()
          } else {
            this.$toast(`${res.msg}`)
          }
        });
    },
    // 创建分组
    handleLevel (type) {
      let { url, params } = { url: '/scrm/v1/ct-speech-group/m/add', params: {} }
      if (type === 1) {
        params = this.paramsLevel1
      } else if (type === 2) {
        params = this.paramsLevel2
      } else {
        params = this.paramsLevel3
      }

      if (params.parentId === null) {
        this.$toast('请选择分组')
        return
      }
      if (!params.name) {
        this.$toast('请填写当前分类')
        return
      }
      this.$http
        .post(url, params)
        .then((res) => {
          if (res.code === 1) {
            this.$toast('新增分组成功')
            // this.initGroupList()
            this.speechgroupList()
            this.$parent.speechgroupList()
            this.handleClose()
          } else {
            this.$toast(`${res.msg}`)
          }
        });
      console.log(url, params, '111111111111111111111');
    }
  }
}
</script>
<style lang="less" scoped>
.popup {
  padding-bottom: 65px;
  .popup-title {
    padding: 22px 20px 30px;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }
  .popup-content {
    padding: 18px 16px;
    font-size: 14px;
    line-height: 24px;
  }
  .popup-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    /deep/.van-button--primary {
      width: 100%;
      background-color: #3974c4;
      border: 0;
      line-height: 45px;
      height: 45px;
    }
  }
}
.group {
  position: relative;
  display: flex;
  padding: 0px 15px 15px;
  font-size: 14px;
  color: #646566;

  /deep/ .van-dropdown-menu__item,
  /deep/ .van-dropdown-menu__bar {
    height: 20px;
    box-shadow: 0 0 0;
  }
  .select-group {
    /deep/ .van-dropdown-menu__title {
      padding-left: 73px;
      font-size: 14px;
    }
  }
  .add-group {
    position: absolute;
    right: 15px;
    padding: 2px 12px;
    // border: 1px solid #3974c4;
    border-radius: 10px;
    // /deep/ .van-dropdown-item {
    //   top: 260px !important;
    // }
    /deep/ .van-dropdown-menu__title {
      font-size: 14px;
      color: #3974c4;
    }
    /deep/ .van-dropdown-menu__item,
    /deep/ .van-dropdown-menu__bar {
      height: 20px;
      box-shadow: 0 0 0;
    }
    .add-wrap-div {
      padding: 8px 15px 10px;
      .m-b-20 {
        position: relative;
        margin: 23px 0 10px;
        padding-bottom: 20px;
      }
      /deep/ .van-button {
        position: absolute;
        right: 0;
        width: 80px;
        height: 25px;
        font-size: 12px;
      }
      .add-div {
        .add-div-flex {
          display: flex;
          align-items: center;
          padding: 0 17px;
          > div {
            margin-right: 20px;
          }
        }
        /deep/ .van-cell {
          width: max-content;
        }
        /deep/ .van-dropdown-menu__title {
          padding-left: 0px;
          font-size: 14px;
          color: #3974c4;
        }
        /deep/ .van-field__label {
          width: 40px;
        }
      }
    }
  }
}
</style>
